<template>
  <div class="l-page l-page--condition-edit">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main
      class="l-main"
      :class="{ 'is-loading': isLoading }"
    >
      <loader />
      <div class="p-breadcrumb">
        <ul class="p-breadcrumb-list">
          <li class="p-breadcrumb-list__item">
            <a href="/coins-admin/condition">保存している配信条件の一覧</a>
          </li>
          <li class="p-breadcrumb-list__item">配信条件の{{ isEdit? '編集' : '新規作成' }}</li>
        </ul>
      </div>
      <!-- /パンくずリスト -->

      <div class="l-main-head">
        <h2 class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">配信条件の{{ isEdit? '編集' : '新規作成' }}</div>
        </h2>
      </div>
      <div class="l-main-content l-main-content--readme">
        <div class="p-condition-readme">
          <div class="p-condition-readme-list">
            <div class="p-condition-readme-list__item">
              <h3 class="c-title">基本的な条件について</h3>
              <div class="c-image"><img src="/assets/img/sketch-condition-01.svg" /></div>
              <div class="c-text">
                配信した次のアクションにつながる条件設定や特定のページに訪問したユーザーに向けて配信する設定など、よく利用される配信条件から選択して作成できます。
                くわしくは<a style="text-decoration: underline;" href="https://manual.webpush.jp/posts/create-seg-basic" target="_blank">こちら</a>
              </div>
            </div>
            <div class="p-condition-readme-list__item">
              <h3 class="c-title">より高度な条件について</h3>
              <div class="c-image"><img src="/assets/img/sketch-condition-02.svg" /></div>
              <div class="c-text">
                自由にカスタマイズ可能なセグメントで絞り込むことで、より高度な条件での配信が可能です。例えば、会員かどうかを<a style="text-decoration: underline;" href="https://manual.webpush.jp/posts/function-customkey1" target="_blank">カスタムキー</a>へ登録し、会員のみへ配信を行うといったことが出来ます。
              </div>
            </div>
            <div class="p-condition-readme-list__item">
              <h3 class="c-title">属性データの条件について</h3>
              <div class="c-image"><img src="/assets/img/sketch-condition-03.svg" /></div>
              <div class="c-text">オーディエンスデータと連携を行い、オプトインユーザーに属性を付与。御社DMPとの連携無しで性別、年代、地域によりセグメント配信が可能になり、非会員ユーザーでも属性別にリーチが行えます。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content l-main-content--segment-group">
        <div v-show="!isEdit" class="p-message-edit p-message-edit--delivery-segment-group">
          <div class="p-message-edit-list p-message-edit-list--first">
            <div class="p-message-edit-list__item">
              <div class="c-radio u-w100p">
                <div class="c-radio__title">セグメントの条件を設定する</div>
                <ul class="c-radio-list">
                  <li class="c-radio-list__item">
                    <label class="c-radio__label u-w300">
                      <input
                        v-model="createType"
                        type="radio"
                        name="select_segment_condition"
                        value="1"
                        @change="createTypeChanged"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">新規作成</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item u-w300">
                    <label class="c-radio__label">
                      <input
                        v-model="createType"
                        type="radio"
                        name="select_segment_condition"
                        value="2"
                        @change="createTypeChanged"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">保存してある条件から選ぶ</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item u-w300">
                    <label class="c-radio__label">
                      <input
                        v-model="createType"
                        type="radio"
                        name="select_segment_condition3"
                        value="3"
                        @change="createTypeChanged"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">保存してある属性条件から選ぶ</div>
                      </div>
                    </label>
                  </li>
                </ul>
                <div class="c-error">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
            <div class="p-message-edit-list__item">
              <div class="c-input u-w300">
                <input
                  v-model="conditionName"
                  class="c-input__item"
                  type="text"
                  name="segment_condition_name"
                  value=""
                  placeholder="配信条件の保存名を入力してください"
                />
                <div class="c-error c-error--balloon c-error--group-name">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <select-text
                ref="conditionSelect"
                input-name="conditionList"
                :classes="['u-w300']"
                place-holder="配信条件を選択してください"
                :elements="conditionInfo.conditions"
                @select="onConditionIdSelect"
              />
              <select-text
                ref="topicConditionSelect"
                input-name="topicConditionList"
                :classes="['u-w300']"
                place-holder="属性条件を選択してください"
                :elements="conditionInfo.topicConditions"
                @select="onTopicConditionIdSelect"
              />
            </div>
          </div>
        </div>
        <div v-show="isEdit" class="p-message-edit p-message-edit--delivery-segment-group">
          <div class="p-message-edit-list p-message-edit-list--first">
            <div class="p-message-edit-list__item">
              <div class="c-radio u-w100p">
                <div class="c-radio__title">セグメントの条件を設定する</div>
              </div>
            </div>
            <div class="p-message-edit-list__item">
              <div class="c-input u-w100p">
                <div class="c-input__title">条件名を設定する</div>
                <input
                  v-model="conditionName"
                  type="text"
                  name="segment_condition_name"
                  value=""
                  placeholder="条件名名を入力してください"
                  class="c-input__item"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content l-main-content--select-condition">
        <div class="p-message-select-condition-type">
          <div class="c-tab">
            <ul class="c-tab-list">
              <li
                v-show="showCondition"
                class="c-tab-list__item"
                :class="isSegment ? '' : 'is-active'"
                data-type="standard"
                @click="onStandardTabClick"
              >基本的な条件から選ぶ</li>
              <!-- <li class="c-tab-list__item" data-type="advanced">より高度な条件を設定する</li> -->
              <li
                v-show="canUseSegment && showTopicCondition"
                class="c-tab-list__item"
                :class="isSegment ? 'is-active' : ''"
                data-type="segment"
                @click="onSegmentTabClick"
              >属性データの条件から選ぶ</li>
            </ul>
          </div>
        </div>
        <div  v-show="showCondition" class="p-message-edit p-message-edit--standard" :class="isSegment ? '' : 'is-active'">
          <div class="p-message-edit-list">
            <!-- AND / OR -->
            <div class="p-message-edit-list__item">
              <div class="c-select-card">
                <ul class="c-select-card-list">
                  <li class="c-select-card-list__item">
                    <label class="c-select-card__label">
                      <input
                        v-model="conditionJoinType"
                        type="radio"
                        name="condition_type"
                        value="AND"
                      />
                      <div class="c-select-card__item">
                        <div class="c-icon u-wh80">
                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/assets/img/sprite.svg#condition-and" />
                          </svg>
                        </div>
                        <div class="c-select-card-content">
                          <div class="c-select-card-content__title">AND条件</div>
                          <div class="c-select-card-content__text">指定したページ条件の全てを満たす</div>
                        </div>
                      </div>
                    </label>
                  </li>
                  <li class="c-select-card-list__item">
                    <label class="c-select-card__label">
                      <input
                        v-model="conditionJoinType"
                        type="radio"
                        name="condition_type"
                        value="OR"
                      />
                      <div class="c-select-card__item">
                        <div class="c-icon u-wh80">
                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/assets/img/sprite.svg#condition-or" />
                          </svg>
                        </div>
                        <div class="c-select-card-content">
                          <div class="c-select-card-content__title">OR条件</div>
                          <div class="c-select-card-content__text">指定したページ条件のどれかを満たす</div>
                        </div>
                      </div>
                    </label>
                  </li>
                </ul>
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
            <template v-for="conditionLabel,conditionKey in conditionInfo.conditionKeyTypes" :key="conditionKey">
              <div class="p-message-edit-list__item ">
                <div class="c-radio">
                  <label class="c-radio__label">
                    <input
                      v-model="conditionDetailKey"
                      type="radio"
                      name="advanced_condition_type"
                      :value="conditionKey"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">{{ conditionLabel }}</div>
                    </div>
                    <div class="c-radio__text">
                      {{ conditionInfo.conditionKeyExplanations[conditionKey] }}
                    </div>
                  </label>
                  <div class="c-error c-error--indent">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--set-custom">
                <div class="p-message-edit-condition-group">
                  <div class="p-message-edit-condition-group__title">{{ conditionLabel }}</div>
                  <template v-for="(conditionDetail, index) in conditionDetailList[conditionKey]" :key="index">
                    <div class="p-message-edit-condition-group__item">
                      <input-optin-time-condition
                        v-if="conditionKey == 'optin_time'"
                        :value="conditionDetail.value"
                        :input-name="conditionKey + '_' + index"
                        @change="conditionDetail.value = $event"
                      />

                      <input-optin-days-condition
                        v-else-if="conditionKey == 'optin_days'"
                        :value="conditionDetail.value"
                        :input-name="conditionKey + '_' + index"
                        @change="conditionDetail.value = $event"
                      />

                      <input-click-time-condition
                        v-else-if="conditionKey == 'click_time'"
                        :value="conditionDetail.value"
                        :input-name="conditionKey + '_' + index"
                        @change="conditionDetail.value = $event"
                      />

                      <input-click-days-condition
                        v-else-if="conditionKey == 'click_days'"
                        :value="conditionDetail.value"
                        :input-name="conditionKey + '_' + index"
                        @change="conditionDetail.value = $event"
                      />

                      <select-text
                        v-else-if="conditionInfo.conditionKeyOptions[conditionKey]"
                        :place-holder="conditionLabel"
                        :classes="['u-w456']"
                        :value="conditionDetail.value"
                        :elements="conditionInfo.conditionKeyOptions[conditionKey]"
                        @select="conditionDetail.value = $event"
                      />

                      <div v-else class="c-input u-w456">
                        <input
                          v-model="conditionDetail.value"
                          class="c-input__item"
                          type="text"
                          :name="conditionKey + '_' + index"
                          placeholder=""
                        />
                        <div class="c-error c-error--balloon">
                          <div class="c-error__text"></div>
                        </div>
                      </div>

                      <select-text
                        place-holder="操作"
                        :classes="['u-w162']"
                        :value="conditionDetail.operator"
                        :elements="conditionInfo.conditionKeyOperators[conditionKey]"
                        @select="conditionDetail.operator = $event"
                      />
                    </div>
                  </template>
                </div>
                <button
                  v-show="conditionKeyCountList[conditionKey] < 20"
                  class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14"
                  type="button"
                  :name="'add_' + conditionKey"
                  value="add_custom_key_condition"
                  @click="onAddConditionDetailClick(conditionKey)"
                >
                  <div class="c-icon-circle c-icon-circle--blue u-wh20">
                    <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#plus" />
                      </svg>
                    </div>
                  </div>
                  <p class="c-btn__text">さらに条件を追加する</p>
                </button>
              </div>
            </template>
          </div>
        </div>
        <div v-show="showTopicCondition" class="p-message-edit p-message-edit--segment" :class="isSegment ? 'is-active' : ''">
          <div class="c-title">
            <div class="c-title__text u-fs24">デモグラフィック（属性）</div>
          </div>
          <div class="p-message-edit-list">
            <div class="p-message-edit-list__item">
              <div class="c-select-label c-select-label--gender">
                <div class="c-select-label__title">性別</div>
                <ul class="c-select-label-list">
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="genders"
                        type="checkbox"
                        name="demogra_gender"
                        :value="allValue"
                        @change="genderAllChanged"
                      />
                      <div class="c-select-label__item">すべて</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="genders"
                        type="checkbox"
                        name="demogra_gender"
                        :value="conditionInfo.demograInfo.topicConditionGenderTypes.Male"
                        @change="genderChanged"
                      />
                      <div class="c-select-label__item">男性</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="genders"
                        type="checkbox"
                        name="demogra_gender"
                        :value="conditionInfo.demograInfo.topicConditionGenderTypes.Female"
                        @change="genderChanged"
                      />
                      <div class="c-select-label__item">女性</div>
                    </label>
                  </li>
                </ul>
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-message-edit-list">
            <div class="p-message-edit-list__item">
              <div class="c-select-label c-select-label--age">
                <div class="c-select-label__title">年齢</div>
                <ul class="c-select-label-list">
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="allValue"
                        @change="ageAllChanged"
                      />
                      <div class="c-select-label__item">すべて</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A15_20"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">15歳-20歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A20_25"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">20歳-25歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A25_30"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">25歳-30歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A30_35"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">30歳-35歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A35_40"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">35歳-40歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A40_45"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">40歳-45歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A45_50"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">45歳-50歳</div>
                    </label>
                  </li>
                  <li class="c-select-label-list__item">
                    <label class="c-select-label__label">
                      <input
                        v-model="ages"
                        type="checkbox"
                        name="demogra_age"
                        :value="conditionInfo.demograInfo.topicConditionAgeTypes.A50_UL"
                        @change="ageChanged"
                      />
                      <div class="c-select-label__item">50歳以上</div>
                    </label>
                  </li>
                </ul>
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>



          <div class="p-message-edit-list">
            <div class="p-message-edit-list__item">
              <select-region-list-item
                ref="refSelectRegionListItem"
                :all-value="allValue"
                :initial-regions="regions"
                :initial-prefectures="prefectures"
                :on-change="onSelectRegionListItemChange"
                :prefecture-types="conditionInfo.demograInfo.topicConditionPrefectureTypes"
                :region-types="conditionInfo.demograInfo.topicConditionRegionTypes"
              />
            </div>
          </div>

          <div class="c-title c-title--wrap c-title--audience ">
            <div class="c-title__text u-fs24">オーディエンス（興味・関心）</div>
            <div class="c-text u-fs--s">
            </div>
          </div>
          <div class="p-message-edit-list">
            <div class="p-message-edit-list__item">
              <select-text
                ref="interest"
                :value="interest"
                :elements="conditionInfo.demograInfo.userInterests"
                :classes="[]"
                :has-blank="true"
                place-holder="ユーザーが興味・関心のあるセグメントを選択"
                input-name="interest_category"
                @select="onInterestSelect"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-condition-btns">
          <a class="c-btn c-btn--gray u-w320 u-h50 u-fs--xl" href="#project" @click="onCancelButtonClick">
            <p class="c-btn__text">キャンセル</p>
          </a>
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs--xl"
            :class="{ 'is-loading': isLoadingSaveBtn }"
            :disabled="isLoadingSaveBtn"
            type="button"
            name="save"
            value="edit"
            @click="onSaveButtonClick"
          >
            <p class="c-btn__text">この内容で条件を保存する</p>
          </button>
        </div>
      </div>
    </main>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    conditionInfo: Object,
    conditionId: String,
    topicConditionId: String,
    copy: Boolean,
  },
  data () {
    return {
      createType: null,
      selectedConditionId: null,
      isLoading: false,
      isLoadingSaveBtn: false,
      conditionName: null,
      conditionDetailList: [],
      conditionDetailKey: null,
      conditionJoinType: 'AND',
      isSegment: false,
      selectedTopicConditionId: null,
      genders: [],
      ages: [],
      regions: [],
      prefectures: [],
      company: [],
      interest: null,
      keyword: null,
      allValue: '9999',
      errorMessage: '',
      isError: false,
      canUseSegment: this.conditionInfo.useSegment || false,
      conditionKeyCountList : {
        page: 1,
        page_history: 1,
        device: 1,
        os: 1,
        browser: 1,
        custom_info_1: 1,
        custom_info_2: 1,
        uuid: 1,
        registration_id: 1,
        meta_keywords: 1,
        title_tag: 1,
        optin_time: 1,
        optin_days: 1,
        click_time: 1,
        click_days: 1,
      }
    }
  },
  computed: {
    isEdit: function() {
      return (this.conditionId || this.topicConditionId);
    },
    showCondition: function() {
      let showCondition = true;
      if(this.topicConditionId){
        showCondition = false;
      }
      if(this.createType == 3){
        showCondition = false;
      }
      return showCondition;
    },
    showTopicCondition: function() {
      let showTopicCondition = true;
      if(this.conditionId){
        showTopicCondition = false;
      }
      if(this.createType == 2){
        showTopicCondition = false;
      }
      return showTopicCondition;
    },
  },

  mounted: function () {
    import('../../funcs/pages/condition-add').then(module => {
      module.ConditionAdd();
    });

    if (location.hash === '#segment') {
      this.isSegment = true;
    }

    this.conditionDetailList = [];
    // 各KeyのConditionDetailを１個ずつ作成しておく
    Object.keys(this.conditionInfo.conditionKeyTypes).map(conditionKey => {
      this.conditionDetailList[conditionKey] = [];
      this.conditionDetailList[conditionKey].push(this.getDefaultValueForConditionKey(conditionKey));
    });

    if(this.conditionId){
      if(this.copy){
        this.createType = 1;
      } else {
        this.createType = 2;
        this.$refs.conditionSelect.setValue(this.conditionId);
        this.selectedConditionId = this.conditionId;
      }
      this.isSegment = false;
      this.loadCondition(this.conditionId);
    } else if(this.topicConditionId){
      if(this.copy){
        this.createType = 1;
      } else {
        this.createType = 3;
        this.$refs.topicConditionSelect.setValue(this.topicConditionId);
        this.selectedTopicConditionId = this.topicConditionId;
      }
      this.isSegment = true;
      this.loadTopicCondition(this.topicConditionId);
    } else {
      this.createType = 1;
    }
  },
  methods: {
    loadCondition: function(conditionId) {
      // 情報取得用パラメタ作成
      const params = {
        params: {
          condition_id: conditionId,
        }
      };
      this.isLoading = true;
      axios.get('/api/condition/get',params)
        .then(res => {
          // this.isLoading = false;
          if(this.handleResponse(res)){
            let condition = res.data.condition;

            if((this.createType == 1) || this.isEdit){
              this.conditionName = condition.condition_name;
            }

            this.conditionJoinType = condition.condition_join_type;
            if(condition.condition_details){
              this.conditionDetailKey = condition.condition_details[0].condition_key;
              this.conditionDetailList[this.conditionDetailKey] = [];
              condition.condition_details.forEach(conditionDetail => {
                this.conditionDetailList[this.conditionDetailKey].push({value:conditionDetail.condition_value,operator:conditionDetail.condition_operation});
              });
              // 配信条件のキーが読み込まれた後に呼び出す
              this.initConditionKeyCounter();
            }
            this.$forceUpdate()
          } else {
            this.isError = true;
            this.errorMessage = '配信条件の設定情報取得に失敗しました';
          }
          setTimeout(() => { this.isLoading = false; }, 300);
        })
        .catch(error => {
          this.isError = true;
          this.errorMessage = '配信条件の設定情報取得に失敗しました';
          this.handleHttpError(error);
          setTimeout(() => { this.isLoading = false; }, 300);
        });
    },
    loadTopicCondition: function (topicConditionId) {
      // 情報取得用パラメタ作成
      const params = {
        params: {
          topic_condition_id: topicConditionId,
        }
      };
      this.isLoading = true;
      axios.get('/api/topic-condition/get', params)
        .then(res => {
          this.isLoading = false;
          if (this.handleResponse(res)) {
            let topicCondition = res.data.topic_condition;
            if ((this.createType == 1) || this.isEdit) {
              this.conditionName = topicCondition.condition_name;
            }
            if (topicCondition.topic_condition_details) {
              this.genders = [];
              this.ages = [];
              this.regions = [];
              this.prefectures = [];
              this.interest = null;
              this.keyword = null;
              topicCondition.topic_condition_details.forEach(topicConditionDetail => {
                if(topicConditionDetail.data_type == 'sex'){
                  if(topicConditionDetail.condition_1 == '男性'){
                    this.genders.push(this.conditionInfo.demograInfo.topicConditionGenderTypes.Male);
                  } else if(topicConditionDetail.condition_1 == '女性'){
                    this.genders.push(this.conditionInfo.demograInfo.topicConditionGenderTypes.Female);
                  }
                  this.genderChanged();
                } else if(topicConditionDetail.data_type == 'age'){
                  if(topicConditionDetail.condition_1 == '15'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A15_20);
                  } else if(topicConditionDetail.condition_1 == '20'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A20_25);
                  } else if(topicConditionDetail.condition_1 == '25'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A25_30);
                  } else if(topicConditionDetail.condition_1 == '30'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A30_35);
                  } else if(topicConditionDetail.condition_1 == '35'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A35_40);
                  } else if(topicConditionDetail.condition_1 == '40'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A40_45);
                  } else if(topicConditionDetail.condition_1 == '45'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A45_50);
                  } else if(topicConditionDetail.condition_1 == '50'){
                    this.ages.push(this.conditionInfo.demograInfo.topicConditionAgeTypes.A50_UL);
                  }
                  this.ageChanged();
                } else if(topicConditionDetail.data_type == 'pref'){
                  if(topicConditionDetail.condition_1 == '北海道'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Hokkaido);
                  } else if(topicConditionDetail.condition_1 == '東北'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Tohoku);
                  } else if(topicConditionDetail.condition_1 == '関東'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Kanto);
                  } else if(topicConditionDetail.condition_1 == '中部'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Chubu);
                  } else if(topicConditionDetail.condition_1 == '近畿'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Kinki);
                  } else if(topicConditionDetail.condition_1 == '中国'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Chugoku);
                  } else if(topicConditionDetail.condition_1 == '四国'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Shikoku);
                  } else if(topicConditionDetail.condition_1 == '九州'){
                    this.regions.push(this.conditionInfo.demograInfo.topicConditionRegionTypes.Kyushu);
                  }
                  this.$refs.refSelectRegionListItem.updateRegions(this.regions);

                } else if(topicConditionDetail.data_type == 'pref_detail'){
                  let prefectureResult = this.conditionInfo.demograInfo.topicConditionPrefectureTypes.filter(v => {
                    return v.name === topicConditionDetail.condition_1;
                  });
                  this.prefectures.push(prefectureResult[0].id);

                } else if(topicConditionDetail.data_type == 'interest'){
                  this.interest = topicConditionDetail.condition_1;
                } else if(topicConditionDetail.data_type == 'keyword'){
                  this.keyword = topicConditionDetail.condition_1;
                } else if (topicConditionDetail.data_type == 'company') {
                  this.company.push(topicConditionDetail.condition_1);
                }
              });
            }

            if (this.prefectures) {
              this.$refs.refSelectRegionListItem.updatePrefectures(this.prefectures);
              this.$refs.refSelectRegionListItem.onPrefectureChange();
            }

            this.$forceUpdate()
          } else {
            this.isError = true;
            this.errorMessage = '配信条件の設定情報取得に失敗しました';
          }
          setTimeout(() => { this.isLoading = false; }, 300);
        })
        .catch(error => {
          this.isError = true;
          this.errorMessage = '配信条件の設定情報取得に失敗しました';
          this.handleHttpError(error);
          setTimeout(() => { this.isLoading = false; }, 300);
        });
    },
    initConditionKeyCounter: function(){
      let keyCount = this.conditionDetailList[this.conditionDetailKey].length;
      // 条件が1つの場合は初期値と同じなので、無視する
      if(keyCount > 1){
        this.conditionKeyCountList[this.conditionDetailKey] = keyCount;
      }
    },
    createTypeChanged: function() {
      if(this.createType == 2){
        this.isSegment = false;
      } else if(this.createType == 3){
        this.isSegment = true;
      }
    },
    onConditionIdSelect: function (conditionId) {
      this.createType = 2;
      this.isSegment = false;
      this.selectedConditionId = conditionId;
      this.loadCondition(conditionId);
    },
    onTopicConditionIdSelect: function (topicConditionId) {
      this.createType = 3;
      this.isSegment = true;
      this.selectedTopicConditionId = topicConditionId;
      this.loadTopicCondition(topicConditionId);
    },
    onAddConditionDetailClick: function(conditionKey){
      this.conditionDetailList[conditionKey].push(this.getDefaultValueForConditionKey(conditionKey));
      this.$forceUpdate();
      this.conditionKeyCountList[conditionKey]++;
    },
    getDefaultValueForConditionKey: function(conditionKey){
      let defaultOperator = 'eq';
      if(conditionKey == 'optin_time'){
        defaultOperator = 'gt';
      } else if(conditionKey == 'optin_days'){
        defaultOperator = 'numgt';
      } else if(conditionKey == 'click_time'){
        defaultOperator = 'gt';
      } else if (conditionKey == 'click_days') {
        defaultOperator = 'numlt';
      }
      return {value:'',operator:defaultOperator};
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    onCancelButtonClick: function(){
      location.href = this.conditionInfo.listUrl;
    },
    onSaveButtonClick: function(){
      let conditionId = 0;
      let topicConditionId = 0;
      let conditionName = '';

      if(this.isEdit){
        conditionName = this.conditionName;
        if(!conditionName){
          this.isError = true;
          this.errorMessage = '配信条件の保存名を入力してください';
          return;
        }
      }

      if(this.createType == 1){
        conditionName = this.conditionName;
        if(!conditionName){
          this.isError = true;
          this.errorMessage = '配信条件の保存名を入力してください';
          return;
        }
      } else if(this.createType == 2){
        if(!this.selectedConditionId){
          this.isError = true;
          this.errorMessage = '配信条件を選択してください';
          return;
        }
        conditionId = this.selectedConditionId;
      } else if(this.createType == 3){
        if(!this.selectedTopicConditionId){
          this.isError = true;
          this.errorMessage = '属性条件を選択してください';
          return;
        }
        topicConditionId = this.selectedTopicConditionId;
      }

      if(this.isSegment){
        if(
          (this.genders.length == 0) &&
          (this.ages.length == 0) &&
          (this.regions.length == 0) &&
          (!this.interest) &&
          (!this.keyword)
        ) {
          this.isError = true;
          this.errorMessage = '属性データの項目を選択してください';
          return;
        }

        let topicConditionName = '';
        if ((this.createType == 1) || this.isEdit){
          topicConditionName = this.conditionName;
          if (!topicConditionName) {
            this.isError = true;
            this.errorMessage = '配信条件の保存名を入力してください';
            return;
          }
        }

        // 設定用パラメタ作成
        let params = new FormData();
        this.appendForm(params,'topic_condition_id',topicConditionId);
        this.appendForm(params,'topic_condition_name',topicConditionName);
        this.appendForm(params,'genders',this.genders);
        this.appendForm(params,'ages',this.ages);
        this.appendForm(params,'regions',this.regions);
        this.appendForm(params,'prefectures',this.prefectures);
        this.appendForm(params,'interest',this.interest);
        this.appendForm(params,'keyword',this.keyword);
        this.appendForm(params,'company',this.company);

        // ローディング表示設定
        this.isLoadingSaveBtn = true;

        axios.post('/api/topic-condition/save', params)
          .then(res => {
            if (this.handleResponse(res)) {
              (res.data.topic_condition_id);
              location.href = this.conditionInfo.listUrl + location.hash;
            } else {
              this.isError = true;
              this.errorMessage = '配信条件の保存に失敗しました';
            }
            setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
          })
          .catch(error => {
            this.isError = true;
            this.errorMessage = '配信条件の保存に失敗しました';
            this.handleHttpError(error);
            setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
          });

      } else {
        if(!this.conditionDetailKey){
          this.isError = true;
          this.errorMessage = '配信条件の項目を選択してください';
          return;
        }

        let cnoditionDetails = this.conditionDetailList[this.conditionDetailKey];
        let hasValue = false;
        cnoditionDetails.forEach(conditionDetail => {
          if(conditionDetail.value){
            hasValue = true;
          }
        });

        if(!hasValue){
          let conditionName = this.conditionInfo.conditionKeyTypes[this.conditionDetailKey];
          this.isError = true;
          this.errorMessage = conditionName + 'の値を入力してください';
          return;
        }

        // 設定用パラメタ作成
        const params = {
          conditions: [
            {
              condition_id: conditionId,
              condition_join_type: this.conditionJoinType,
              condition_name: conditionName,
              condition_key: this.conditionDetailKey,
              condition_details: cnoditionDetails,
            }
          ],
        };

        // ローディング表示設定
        this.isLoadingSaveBtn = true;

        axios.post('/api/condition/save',params)
          .then(res => {
            if(this.handleResponse(res)){
              location.href = this.conditionInfo.listUrl + location.hash;
            } else {
              this.isError = true;
              this.errorMessage = '配信条件の保存に失敗しました';
            }
            setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
          })
          .catch(error => {
            this.isError = true;
            this.errorMessage = '配信条件の保存に失敗しました';
            this.handleHttpError(error);
            setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
          });
      }
    },

    genderAllChanged: function() {
      if(this.genders.includes(this.allValue)){
        this.genders = [
          this.allValue,
          this.conditionInfo.demograInfo.topicConditionGenderTypes.Male,
          this.conditionInfo.demograInfo.topicConditionGenderTypes.Female,
        ];
      } else {
        this.genders = [];
      }
    },
    genderChanged: function() {
      let diff = [
        this.conditionInfo.demograInfo.topicConditionGenderTypes.Male,
        this.conditionInfo.demograInfo.topicConditionGenderTypes.Female
      ].filter(value => !this.genders.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.genders.includes(this.allValue)){
          this.genders.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.genders.indexOf(this.allValue)
        if(index >= 0){
          this.genders.splice(index,1);
        }
      }
    },
    ageAllChanged: function() {
      if(this.ages.includes(this.allValue)){
        this.ages = [
          this.allValue,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A15_20,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A20_25,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A25_30,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A30_35,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A35_40,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A40_45,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A45_50,
          this.conditionInfo.demograInfo.topicConditionAgeTypes.A50_UL,
        ];
      } else {
        this.ages = [];
      }
    },
    ageChanged: function() {
      let diff = [
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A15_20,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A20_25,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A25_30,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A30_35,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A35_40,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A40_45,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A45_50,
        this.conditionInfo.demograInfo.topicConditionAgeTypes.A50_UL
      ].filter(value => !this.ages.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.ages.includes(this.allValue)){
          this.ages.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.ages.indexOf(this.allValue)
        if(index >= 0){
          this.ages.splice(index,1);
        }
      }
    },
    regionAllChanged: function() {
      if(this.regions.includes(this.allValue)){
        this.regions = [
          this.allValue,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Hokkaido,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Tohoku,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Kanto,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Chubu,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Kinki,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Chugoku,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Shikoku,
          this.conditionInfo.demograInfo.topicConditionRegionTypes.Kyushu
        ];
      } else {
        this.regions = [];
      }
    },
    regionChanged: function() {
      let diff = [
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Hokkaido,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Tohoku,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Kanto,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Chubu,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Kinki,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Chugoku,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Shikoku,
        this.conditionInfo.demograInfo.topicConditionRegionTypes.Kyushu
      ].filter(value => !this.regions.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.regions.includes(this.allValue)){
          this.regions.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.regions.indexOf(this.allValue)
        if(index >= 0){
          this.regions.splice(index,1);
        }
      }
    },
    companyChanged: function() {
      if (this.company.length > 1) {
        this.company.splice(0, 1);
      }
    },
    onInterestSelect: function(selected) {
      this.interest = selected;
    },
    onKeywordSelect: function(selected) {
      this.keyword = selected;
    },
    onStandardTabClick: function() {
      this.isSegment = false;
      location.hash = 'standard';
    },
    onSegmentTabClick: function() {
      this.isSegment = true;
      location.hash = 'segment';
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onSelectRegionListItemChange: function(regions, prefectures) {
      this.regions = regions;
      this.prefectures = prefectures;
    },
  },
}
</script>
